import React, { useState, useContext, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Select } from 'antd';
import Input from '../../../../ui/Input';
import PageContainer from '../../../../CSIComponents/PageContainer';
import { isEditStateContext, isSaveContext } from '../../../../../store/editableContext'
import { getData, post } from '../../apiCalls'
import Loader from '../../../../Loading'

declare global {
  interface Window {
    otherAmenitiesRatesView: boolean,
    otherAmenitiesRatesViewBody: {
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string
    },
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    }
  }
}

const RatesView = () => {

  const [DayRateAvailability, setDayRateAvailability] = useState('')
  const [DayRateCost, setDayRateCost] = useState('')
  const [DayRateOnProperty, setDayRateOnProperty] = useState('')
  const [DayRateNotes, setDayRateNotes] = useState('')
  const [ready, setReady] = useState<boolean>(false)

  const [rateOptions] = useState<string[]>([
    'Available', 
    'Availiable at a Charge', 
    'Complimentary to All', 
    'Complimentary to Consortia Only', 
    'Cost not known or varies', 
    'Not Available', 
    'Subject to Availability'
  ])

  const [rateProperties] = useState<string[]>([
    'Yes', 
    'No'
  ]) 

  const [form] = Form.useForm();
  const { Option } = Select;

  const context = useContext(isEditStateContext)
  const saveContext = useContext(isSaveContext)

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const onCancelEdition = () => {
    return window.cancelEdition()
  }

  const saveAction = async () => {
    const body = {
      "dayrateavail":  DayRateAvailability,
      "dayratecost": DayRateCost,
      "dayrateprop": DayRateOnProperty,
      "dayratenote": DayRateNotes,
    }
    window.otherAmenitiesRatesViewBody = body
    await post()
    await getData()
  }

  const watcher = async () => {
       // save button functionality for other amenities
       const errors = await document.getElementsByClassName('ant-form-item-explain-error')
       const saveBtn: any = document.querySelectorAll('[data-test="save-btn"]')
       if ( errors.length <= 0) {
         for (let i = 0; i < saveBtn.length; i++) {
           saveBtn[i]?.classList?.remove("is-disabled")
         } 
       } else {
         for (let i = 0; i < saveBtn.length; i++) {
           saveBtn[i]?.classList?.add("is-disabled")
         }
       }
     }


  useEffect(() => {
    // adding listeners
        window.addEventListener('input', () => { watcher() })
        window.addEventListener('change', () => { watcher() })
        window.addEventListener('click', () => { watcher() })
        window.addEventListener('mousemove', async () => { await watcher() })
        window.addEventListener('keydown', async () => { await watcher() })


    const get = async () => {
      const response = await getData()
      setDayRateAvailability(response.dayrateavail)
      setDayRateCost(response.dayratecost)
      setDayRateOnProperty(response.dayrateprop)
      setDayRateNotes(response.dayratenote)
      setReady(true)
    }
    get()
  },[])
 
  useEffect(() => {
    if (context) {
      // removing action buttons
      const buttons: any = document.getElementsByClassName('ligthButton')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].classList.add('d-none')
      }
    }
  },[context])

  useEffect(() => {
    if (saveContext) {
      saveAction()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[saveContext])

  useEffect(() => {
    function validation() {
    const onlyNumbers = /^[1-9]\d*$/
    const maxLength = /^(.){0,225}$/
      if ((
      onlyNumbers.test(DayRateCost)
      || DayRateCost === null
      || DayRateCost === '')
      && (maxLength.test(DayRateNotes)
      || DayRateNotes === null
      || DayRateNotes === '')
      ) {
        return window.otherAmenitiesRatesView = true
      }
      return window.otherAmenitiesRatesView = false
    }
    validation()
  }, [DayRateCost, DayRateNotes])

  return (
    <>
      { ready ?
        <PageContainer>
        <Grid container spacing={0} className="containerSpacing py-0">
          <Grid item xs={12} className="pb-0 px-0 my-0">
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{
                "DayRateAvailability": DayRateAvailability,
                "DayRateOnProperty": DayRateOnProperty, 
                "DayRateNotes": DayRateNotes,
                "DayRateCost": DayRateCost,
              }}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name='DayRateAvailability'
                    label="Day Rate Availability">
                    <Select allowClear onChange={(e: string) => setDayRateAvailability(e)}
                      showSearch
                    >
                      {
                        rateOptions.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Day Rate Cost"
                    name="DayRateCost"
                    rules={[{ pattern: /^[-+]?[0-9]*\.?[0-9]*$/, message: 'This field should be a number' }]}
                  >
                    <Input 
                      onChange={(e: any) => setDayRateCost(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name='DayRateOnProperty'
                    label="Day Rate On Property">
                    <Select allowClear onChange={(e: string) => setDayRateOnProperty(e)}
                      showSearch
                    >
                      {
                        rateProperties.map((rt: string, index: number) => (
                          <Option value={rt} key={index}>{rt}</Option>
                        ))
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Day Rate Notes"
                    name="DayRateNotes"
                    rules={[{ max: 225, message: 'You have reached the max character length of 225' }]}
                  >
                    <Input
                      maxLength={225}
                      edit={context}
                      onChange={(e: any) => setDayRateNotes(e.target.value)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
    </PageContainer>
    : <Loader type="medium" />
    }
    </>
  )
}

export default RatesView
